module.exports = __webpack_public_path__ + "img/google.66ca7bdd.svg";